module.exports = {
    Ready: 'Ready',
    InProgress: 'InProgress',
    Finished: 'Finished',
};
